.k8{gap:0.125rem;}